import type {
  HoldingUnitContainerKind,
  HoldingUnitIdentityMode,
  HoldingUnitReservationTargetType,
  HoldingUnitLifecycleStatus,
} from './holding-units.dto.js';

export const fixedIdAssetStateValues = [
  'available',
  'in_use',
  'offsite',
  'maintenance',
  'retired',
] as const;
export type FixedIdAssetState = (typeof fixedIdAssetStateValues)[number];

export const fixedIdAssetAvailabilityReasonValues = [
  'AVAILABLE',
  'ACTIVE_CYCLE_OPEN',
  'ACTIVE_CYCLE_READY',
  'RESERVED_LOAD_SESSION',
  'RESERVED_SHIPMENT',
  'RESERVED_OTHER',
  'ASSET_OFFSITE',
  'ASSET_MAINTENANCE',
  'ASSET_RETIRED',
] as const;
export type FixedIdAssetAvailabilityReason = (typeof fixedIdAssetAvailabilityReasonValues)[number];

export interface FixedIdAssetSnapshot {
  id: string;
  companyId: string;
  homeStoreId: string;
  homeLocationId: string;
  lastKnownStoreId: string;
  lastKnownLocationId: string;
  lastKnownYardLocationId: string | null;
  identityMode: Extract<HoldingUnitIdentityMode, 'fixed_asset_cycle'>;
  containerKind: Extract<HoldingUnitContainerKind, 'heavy_container'>;
  physicalId: string;
  normalizedPhysicalId: string;
  normalizedScannableIdentifier: string;
  masterTareLb: number;
  state: FixedIdAssetState;
  activeCycleUnitId: string | null;
  version: number;
  createdAt: string; // ISO datetime
  updatedAt: string; // ISO datetime
}

export interface FixedIdAssetRegistryItem extends FixedIdAssetSnapshot {
  activeCycleLifecycleStatus: Extract<HoldingUnitLifecycleStatus, 'open' | 'ready'> | null;
  isAvailable: boolean;
  unavailableReason: FixedIdAssetAvailabilityReason;
  unitId?: string | null;
  lifecycleStatus?: HoldingUnitLifecycleStatus | null;
  reservationType?: HoldingUnitReservationTargetType | null;
  loadSessionId?: string | null;
  shipmentId?: string | null;
}
